import {ORDINARY, TURBO, TURBO_PLUS} from "./taskTypes";

export const levels = [
    {
        value: 1,
        name: 'Просто'
    }, {
        value: 2,
        name: 'Братья'
    }, {
        value: 3,
        name: 'Друзья'
    }, {
        value: 4,
        name: 'Переход'
    }, {
        value: 5,
        name: 'Анзан'
    },
]


export const themes = [
    {
        category: "Просто"
    }, {
        value: "SIMPLE_4",
        name: 'Просто 4'
    }, {
        value: "SIMPLE_5",
        name: 'Просто 5'
    }, {
        value: "SIMPLE_6",
        name: 'Просто 6'
    }, {
        value: "SIMPLE_7",
        name: 'Просто 7'
    }, {
        value: "SIMPLE_8",
        name: 'Просто 8'
    }, {
        value: "SIMPLE_9",
        name: 'Просто 9'
    }, {
        category: "Братья"
    }, {
        value: "BROTHERS_4",
        name: 'Братья 4'
    }, {
        value: "BROTHERS_3",
        name: 'Братья 3'
    }, {
        value: "BROTHERS_2",
        name: 'Братья 2'
    }, {
        value: "BROTHERS_1",
        name: 'Братья 1'
    }, {
        category: "Друзья"
    }, {
        value: "FRIEND_9",
        name: 'Друзья 9'
    }, {
        value: "FRIEND_8",
        name: 'Друзья 8'
    }, {
        value: "FRIEND_7",
        name: 'Друзья 7'
    }, {
        value: "FRIEND_6",
        name: 'Друзья 6'
    }, {
        value: "FRIEND_5",
        name: 'Друзья 5'
    }, {
        value: "FRIEND_4",
        name: 'Друзья 4'
    }, {
        value: "FRIEND_3",
        name: 'Друзья 3'
    }, {
        value: "FRIEND_2",
        name: 'Друзья 2'
    }, {
        value: "FRIEND_1",
        name: 'Друзья 1'
    }, {
        category: "Переход"
    }, {
        value: "JUMP_50",
        name: 'Переход 50'
    }, {
        value: "JUMP_100",
        name: 'Переход 100'
    }, {
        category: "Анзан"
    },  {
        value: "ANZAN_1",
        name: 'Анзан'
    },
]

export const solveTypes = [
    {
        value: "ABACUS",
        name: 'На абакусе'
    }, {
        value: "MENTAL",
        name: 'Ментально'
    },
]

export const taskTypes = [
    {
        value: ORDINARY,
        name: "Обычный",
    }, {
        value: TURBO,
        name: "Турбо",
    }, {
        value: TURBO_PLUS,
        name: "Турбо Плюс",
    },
]

export const getNameByValue = (arr, value) => {
    let res;
    arr.forEach(a => {
        if (a.value === value) {
            res = a.name
        }
    })
    return res;
}

export const complexities = [
    {
        value: 0,
        label: 1
    }, {
        value: 1,
        label: 10
    }, {
        value: 2,
        label: 100
    }, {
        value: 3,
        label: 1000
    }, {
        value: 4,
        label: 10000
    },
]

export const speeds = [
    {
        value: 0.1,
        label: 0.1
    }, {
        value: 2.5,
        label: 2.5
    }, {
        value: 5,
        label: 5
    }, {
        value: 7.5,
        label: 7.5
    }, {
        value: 10,
        label: 10
    },
]

export const lengths = [
    {
        value: 1,
        label: 1
    }, {
        value: 25,
        label: 25
    },  {
        value: 50,
        label: 50
    }, {
        value: 75,
        label: 75
    }, {
        value: 100,
        label: 100
    },
]

export const counts = [
    {
        value: 1,
        label: 1
    }, {
        value: 25,
        label: 25
    }, {
        value: 50,
        label: 50
    }, {
        value: 75,
        label: 75
    }, {
        value: 100,
        label: 100
    },
]